export default __webpack_public_path__ + "static/media/Rauch&Gursky_Still_1.0b99292c.jpg";